( function( app ) {
  const COMPONENT = {
    init: function() {
      const isMobile = function() {
        return window.innerWidth < 1024;
      };

      const forceOpenOnMobile = function() {
        if ( !isMobile() ) return;
        $( '.image-accordion-steps__step' ).addClass( 'is-open' );
      };

      const measureStepHeights = function() {
        if ( !isMobile() ) {
          $( '.image-accordion-steps__step-content' ).css( 'height', '' );
          return;
        }

        $( '.image-accordion-steps__step-content' ).each( function() {
          const $content = $( this );
          const isOpen = $content.closest( '.image-accordion-steps__step' ).hasClass( 'is-open' );

          $content.css( 'height', '' );
          $content.css( 'transition', 'none' );
          const naturalHeight = $content.outerHeight();
          $content.attr( 'data-height', naturalHeight );

          $content.css( 'height', isOpen ? naturalHeight + 'px' : '0px' );

          requestAnimationFrame( function() {
            $content.css( 'transition', '' );
          } );
        } );
      };

      forceOpenOnMobile();
      measureStepHeights();

      $( '.image-accordion-steps__step' ).each( function() {
        const observer = new MutationObserver( function( mutations ) {
          mutations.forEach( function( mutation ) {
            if ( mutation.attributeName !== 'class' ) return;
            if ( !isMobile() ) return;

            const $button = $( mutation.target );

            // No open/close functionality on mobile: steps must stay open.
            if ( !$button.hasClass( 'is-open' ) ) {
              $button.addClass( 'is-open' );
              return;
            }

            const $content = $button.find( '.image-accordion-steps__step-content' );
            const storedHeight = $content.attr( 'data-height' );
            $content.css( 'height', storedHeight + 'px' );
          } );
        } );

        observer.observe( this, {attributes: true} );
      } );

      // Prevent the toggle click (bound by the toggle-state library) from
      // ever reaching the step buttons on mobile, so nothing can collapse.
      document.addEventListener( 'click', function( event ) {
        if ( !isMobile() ) return;
        if ( event.target.closest( '.image-accordion-steps__step' ) ) {
          event.stopPropagation();
        }
      }, true );

      const debouncedMeasure = new app.components.common.Debounce( function() {
        forceOpenOnMobile();
        measureStepHeights();
      }, 250 );
      $( window ).on( 'resize', function() {
        debouncedMeasure.run();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'image-accordion-steps', COMPONENT );
} )( app );
